import type { Item } from '@/lib/api/types/items';
import { ReadOnlyAdapterError } from '@/lib/mutations/item-store/dependencyErrors';
import type { DependencyTabAdapter } from '../types';

export const createReadOnlyDependencyAdapter = ({
  item: _item,
}: {
  item: Item;
}): DependencyTabAdapter => {
  const isEditable = (_dependencyId?: number): boolean => false;
  const isDisabled = (_dependencyId?: number): boolean => false;
  const isVisible = (_dependencyId?: number): boolean => true;
  const canAddDependency = (): boolean => false;
  const addDependency = async (_predecessorId: number, _successorId: number): Promise<void> => {
    throw new ReadOnlyAdapterError();
  };
  const removeDependency = async (_predecessorId: number, _successorId: number): Promise<void> => {
    throw new ReadOnlyAdapterError();
  };

  return {
    isEditable,
    isDisabled,
    isVisible,
    canAddDependency,
    addDependency,
    removeDependency,
  };
};
